import { Vue, Component, Watch } from 'vue-property-decorator';
import { documentReportListService } from './DocumentReport.services';
import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';
// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

@Component
export default class DocumentReport extends Vue{
        
    public buttonDisabled: boolean = false;
    public documentList: any;
    public startDate: any;
    public endDate: any;
    public documentName: any;
    public submitted:boolean = false;
    public showModal: boolean = false;
    public filterData: boolean = false;
    public options: any;
    public options2: any;
    public isEndDisabled: boolean = true;
    public myclass: any;
    public fullPage: boolean = false;
    public $loading: any;
    public data(){
        return{
            startDate: '',
            endDate: '',
            documentName: '',
            showModal: false,
            options: {
            format: 'YYYY-MM-DD',
            useCurrent: false,
            },
            options2: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
                minDate: null
                },
            search: '',
            submitted: false,
            buttonDisabled: false,
            pagination: {
                ascending: true,
                sortBy:"document_name",
                rowsPerPage: 5,
                page: 1
            },
 
        headers: [
          {
            text: 'Document Name',
            align: 'left',
            sortable: true,
            value: 'document_name',
          },
          { text: 'Date', value: 'timestamp',align:'center' },
          { text: 'Count', value: 'count',align:'left'}
        ],
        documentList: [],
        filterData: false,
        isEndDisabled: true,
      }
    }

    mounted(){
        this.getDocumentReportListing();
    }

    reloadPreviousData(): void{
        this.getDocumentReportListing();
    }

    filterTable(){
        this.buttonDisabled = true;
        this.submitted = true;
        this.$validator.validate().then(valid => {
            let postData = {
                data:{
                    document_name: this.documentName,
                    start_date: this.startDate,
                    end_date: this.endDate
                }
            }
            if (valid) {
                this.getDocumentReportListReportFilter(postData);
                this.$bvModal.hide('modal-1');
            }else{
                this.buttonDisabled = false;
            }
    });
    }

    public async getDocumentReportListing(): Promise<void>{
        let token = localStorage.getItem("token");
        let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            // onCancel: this.onCancel,
          });          
        const res = documentReportListService.getDocumentReportList(token).then((res:any) => {
            // console.log(res);
            console.log(res.data.data);
            loader.hide();
            this.documentList = res.data.data.report_list;
            if(this.filterData){
                this.filterData = false;
            }
        }).catch((err:any) => {
            console.log(err);
            loader.hide();
        })
    }

    public async getDocumentReportListReportFilter(saveData:any){
        let token = localStorage.getItem("token");
        let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            // onCancel: this.onCancel,
          });
        const res = documentReportListService.getDocumentReportListReportFilter(saveData,token).then((res: any) =>{
            console.log(res.data.data);
            this.documentList = res.data.data.report_list;
            this.filterData = true;
            this.buttonDisabled = false;
           // this.$bvModal.hide('modal-1');
            this.documentName = '';
            this.startDate = '';
            this.endDate = '';
            loader.hide();
        }).catch((err: any) =>{
            console.log(err);
            loader.hide();
        })
    }

    @Watch('startDate')
    onStartDateChanged(value: string,oldValue: string){
        if(this.startDate){
            this.options2.minDate = moment(this.startDate).format('YYYY-MM-DD');
            this.isEndDisabled = false;           
        }else{
            this.options2.minDate = null;
            this.isEndDisabled = true;
        }
    }
}